/** DOM id for the lazily injected Pendo agent script tag. */
export const PENDO_SCRIPT_ID = 'cnh-pendo-agent-script';

/** Base CDN path for the Pendo agent; the API key and `pendo.js` are appended at runtime. */
export const PENDO_AGENT_CDN_BASE = 'https://cdn.pendo.io/agent/static';

/** Agreed Pendo visitor metadata field names — no PII beyond the opaque user token (visitor id). */
export const PENDO_VISITOR_METADATA_KEYS = {
  ageBand: 'ageBand',
  partyType: 'partyType',
  city: 'city',
  postalCode: 'postalCode',
  state: 'state',
  country: 'country',
  environment: 'environment',
} as const;
